import {Component, ViewChild} from "@angular/core"; import { Location } from "@angular/common";
import {DynamicDialogRef} from 'primeng/dynamicdialog';
import {DynamicDialogConfig} from 'primeng/dynamicdialog';
import { EmployeEntite } from '../entites/employe';
import { DonneesBaseService } from '../services/donnees-base-service';
import { LocalisationService } from '../services/localisation-service';
import { AdresseEntite } from '../entites/adresse';
import { BaseComponent } from '../base/base-component';
import { ProfilService } from '../services/profil-service';
import { ActivatedRoute, Router } from '@angular/router';
import { AppMainComponent } from '../app.main.component';
import { MessageService } from 'primeng/api';

@Component({
    templateUrl: './recherche-adresse.component.html',
})
export class RechercheAdresseComponent extends BaseComponent {

    numero?: string;
    codePostal?: string;
    
    @ViewChild('champNumero') champNumero;
            
    constructor(
        profilService: ProfilService,
        route: ActivatedRoute, 
        routerService: Router,
		appMain: AppMainComponent, location: Location, 
        public messageService: MessageService,
        public sdb: DonneesBaseService,
        private localisationService: LocalisationService,
        public ref: DynamicDialogRef, 
        public config: DynamicDialogConfig) {
            super(sdb, profilService, route, routerService, appMain);
         }

    ngOnInit() {
    }

    surEntree() {
        this.confirmer();
    }

    confirmer() {
        this.Bloquer();

        this.localisationService.rechercherAdresseParNumeroEtCodePostal(this.numero, this.codePostal)
            .subscribe({
                next: (res) => {
                    this.Debloquer();
                    if (res.estUnSucces && res.valeur && res.valeur.length > 0) {
                        // Take the first result from the list
                        const adresse = res.valeur[0];
                        var retour: AdresseEntite = {
                            numero: adresse.numero,
                            rue: adresse.rue,
                            municipalite: adresse.municipalite,
                            codePostal: adresse.codePostal,
                            province: adresse.province || 'Québec',
                            pays: adresse.pays || 'Canada'
                        };
                
                        this.ref.close(retour);
                    } else {
                        this.messageService.add({ 
                            key: 'rechercheAdresse', 
                            severity: 'error', 
                            summary: 'Erreurs', 
                            detail: res.messages[0].description || 'Adresse introuvable.' 
                        });
                    }
                },
                error: (err) => {
                    this.Debloquer();
                    this.messageService.add({ 
                        key: 'rechercheAdresse', 
                        severity: 'error', 
                        summary: 'Erreur', 
                        detail: 'Une erreur est survenue lors de la recherche d\'adresse.' 
                    });
                }
            });
    }

    annuler() {
        this.ref.close(null);
    }
}